var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subscription-page"},[(_vm.step === 0)?_c('choose-plan',{attrs:{"selected":_vm.priceId},on:{"selected":_vm.selectedPrice}}):_vm._e(),(_vm.step === 1)?_c('add-card-step',{attrs:{"priceId":_vm.priceId},on:{"submit":_vm.submit}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }